<template>
  <v-container fluid>
    <div class="social-media-tags mt-7">
      <a class="font-weight-bold text-h6 text-sm-h5 text-white" v-for="(tag, index) in tags" :key="index" :href="`https://twitter.com/hashtag/${tag}?src=hash`" target="_blank">
        #{{ tag }}
      </a>
    </div>
  </v-container>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  tags: {
    type: Array,
    default: () => []
  }
});



</script>

<style scoped>
.social-media-tags a {
  margin-right: 10px;
  text-decoration: none;
}
</style>
